var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showMapper)?_c('MappingTool'):(_vm.$route.name === 'projectMappingsMappingsCreate')?_c('Create'):(_vm.$route.name === 'projectMappingsMappingsDetails')?_c('Details'):_c('Table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }